export default function TabPanel({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        maxWidth: "100%",
        display: "flex",
        gap: "16px",
        flexDirection: "column",
      }}
    >
      {children}
    </div>
  );
}
